export const COOKIE_CONSENT_KEY = "cookie_consent_accepted";
export const COOKIE_CONSENT_ACCEPTED_EVENT = "cookie-consent-accepted";

export function hasCookieConsent(): boolean {
  if (typeof window === "undefined") return false;

  try {
    return window.localStorage.getItem(COOKIE_CONSENT_KEY) === "true";
  } catch {
    return false;
  }
}

export function acceptCookieConsent(): void {
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, "true");
  } catch {
    // Storage can be unavailable in some browser modes; still honor the click
    // for the current tab by notifying consent listeners.
  }

  window.dispatchEvent(new Event(COOKIE_CONSENT_ACCEPTED_EVENT));
}
